
            const data = {"name":"telephone-circle","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M256 43C138 43 43 138 43 256s95 213 213 213 213-95 213-213S374 43 256 43zm108 334h-63v-1c-82-3-148-69-151-151h-1v-63c0-7 6-13 13-13h51c7 0 12 6 12 13v51c0 7-5 12-12 12h-25c3 61 52 110 113 114v-25c0-7 6-13 13-13h50c7 0 13 6 13 13v50c0 7-6 13-13 13z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    